
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as _91id_931s07n7KMJWDnZrLUYAVaUbSMsEEgLXPpaSD6WL_45x_45QQMeta } from "/app/pages/gplay/[id].vue?macro=true";
import { default as indexDwrFXbkKvAO3KBSapONE0nMyMzn0qlLI6E3m7o7_45I5oMeta } from "/app/pages/gplay/index.vue?macro=true";
import { default as gplayjB2Q9yh2jrn30hIDlWSwrssrByNRnjEFNgRwVmHsWC8Meta } from "/app/pages/gplay.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as locationNXpdj_Fd3H2NyGDwWwNd4z0dHbdzzTyyY8Scjr82_CMMeta } from "/app/pages/location.vue?macro=true";
import { default as _91id_93SCC_45TYRYE5EXjYR8gn71RewudDIbZtNjCh0XhK84oesMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as _91id_93rAbU6aYbhIulPFf6cTnSfCBsGB0tcfrradhe8WwrtWcMeta } from "/app/pages/awards/[id].vue?macro=true";
import { default as index_45Ob6G8AnyIFRqcaIVFJRq2340rxPjaOAx_45w_bYZ1cbYMeta } from "/app/pages/awards/index.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about___zh",
    path: "/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ja",
    path: "/ja/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "about___ko",
    path: "/ko/about",
    component: () => import("/app/pages/about.vue")
  },
  {
    name: gplayjB2Q9yh2jrn30hIDlWSwrssrByNRnjEFNgRwVmHsWC8Meta?.name,
    path: "/gplay",
    component: () => import("/app/pages/gplay.vue"),
    children: [
  {
    name: "gplay-id___zh",
    path: ":id()",
    component: () => import("/app/pages/gplay/[id].vue")
  },
  {
    name: "gplay___zh",
    path: "",
    component: () => import("/app/pages/gplay/index.vue")
  }
]
  },
  {
    name: gplayjB2Q9yh2jrn30hIDlWSwrssrByNRnjEFNgRwVmHsWC8Meta?.name,
    path: "/en/gplay",
    component: () => import("/app/pages/gplay.vue"),
    children: [
  {
    name: "gplay-id___en",
    path: ":id()",
    component: () => import("/app/pages/gplay/[id].vue")
  },
  {
    name: "gplay___en",
    path: "",
    component: () => import("/app/pages/gplay/index.vue")
  }
]
  },
  {
    name: gplayjB2Q9yh2jrn30hIDlWSwrssrByNRnjEFNgRwVmHsWC8Meta?.name,
    path: "/ja/gplay",
    component: () => import("/app/pages/gplay.vue"),
    children: [
  {
    name: "gplay-id___ja",
    path: ":id()",
    component: () => import("/app/pages/gplay/[id].vue")
  },
  {
    name: "gplay___ja",
    path: "",
    component: () => import("/app/pages/gplay/index.vue")
  }
]
  },
  {
    name: gplayjB2Q9yh2jrn30hIDlWSwrssrByNRnjEFNgRwVmHsWC8Meta?.name,
    path: "/ko/gplay",
    component: () => import("/app/pages/gplay.vue"),
    children: [
  {
    name: "gplay-id___ko",
    path: ":id()",
    component: () => import("/app/pages/gplay/[id].vue")
  },
  {
    name: "gplay___ko",
    path: "",
    component: () => import("/app/pages/gplay/index.vue")
  }
]
  },
  {
    name: "index___zh",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___zh",
    path: "/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ja",
    path: "/ja/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___ko",
    path: "/ko/search",
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "location___zh",
    path: "/location",
    component: () => import("/app/pages/location.vue")
  },
  {
    name: "location___en",
    path: "/en/location",
    component: () => import("/app/pages/location.vue")
  },
  {
    name: "location___ja",
    path: "/ja/location",
    component: () => import("/app/pages/location.vue")
  },
  {
    name: "location___ko",
    path: "/ko/location",
    component: () => import("/app/pages/location.vue")
  },
  {
    name: "news-id___zh",
    path: "/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ja",
    path: "/ja/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news-id___ko",
    path: "/ko/news/:id()",
    component: () => import("/app/pages/news/[id].vue")
  },
  {
    name: "news___zh",
    path: "/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ja",
    path: "/ja/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "news___ko",
    path: "/ko/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "awards-id___zh",
    path: "/awards/:id()",
    component: () => import("/app/pages/awards/[id].vue")
  },
  {
    name: "awards-id___en",
    path: "/en/awards/:id()",
    component: () => import("/app/pages/awards/[id].vue")
  },
  {
    name: "awards-id___ja",
    path: "/ja/awards/:id()",
    component: () => import("/app/pages/awards/[id].vue")
  },
  {
    name: "awards-id___ko",
    path: "/ko/awards/:id()",
    component: () => import("/app/pages/awards/[id].vue")
  },
  {
    name: "awards___zh",
    path: "/awards",
    component: () => import("/app/pages/awards/index.vue")
  },
  {
    name: "awards___en",
    path: "/en/awards",
    component: () => import("/app/pages/awards/index.vue")
  },
  {
    name: "awards___ja",
    path: "/ja/awards",
    component: () => import("/app/pages/awards/index.vue")
  },
  {
    name: "awards___ko",
    path: "/ko/awards",
    component: () => import("/app/pages/awards/index.vue")
  },
  {
    name: "privacy-policy___zh",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/ja/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ko",
    path: "/ko/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ja/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/ko/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]